import useFetch, { CachePolicies } from 'use-http';

import { MARKETPLACE_GWT } from '@marketplace/common';

import { API_ROUTES } from '../../constants';
import type { TAPIPutDeveloperResponse, TAPIPutDeveloper } from './register-external-developer.types';

export const useAPIRegisterExternalDeveloper = (): TAPIPutDeveloper => {
  const { data, error, post, response, loading } = useFetch(API_ROUTES.DEVELOPERS, {
    headers: {
      Authorization: 'Bearer '+localStorage.getItem(MARKETPLACE_GWT)
    },
    cachePolicy: CachePolicies.NO_CACHE
  });

  const registerExternalDeveloper = (): Promise<TAPIPutDeveloperResponse> =>
    post(`/register-external-developer`);

  return {
    data: data?.data || data,
    error,
    loaded: response?.ok,
    loading,
    registerExternalDeveloper,
  };
};
